/**
 * Tiny shared utilities. No framework — matching the source's philosophy of
 * per-feature vanilla modules.
 */
window.Dylys = window.Dylys || {};

(function (N) {
  'use strict';

  // Body scroll lock. Compensates the vanishing scrollbar width (Windows classic
  // scrollbars) so the page never jumps sideways when an overlay opens.
  var scrollLocked = false;
  N.lockScroll = function () {
    if (scrollLocked) return;
    scrollLocked = true;
    var comp = window.innerWidth - document.documentElement.clientWidth;
    if (comp > 0) document.body.style.paddingRight = comp + 'px';
    document.body.style.overflow = 'hidden';
  };

  N.unlockScroll = function () {
    if (!scrollLocked) return;
    scrollLocked = false;
    document.body.style.overflow = '';
    document.body.style.paddingRight = '';
  };

  // Shared money formatter target: German format is configured shop-side
  // ({{amount_with_comma_separator}} €); JS should not re-format prices.
})(window.Dylys);
